import React from "react"
import Layout from "../components/layout"
import PeopleGrid from "../components/people-grid"
import SubNavigation from "../components/sub-navigation"
import Hero from "../components/hero"
import Image from "../components/image"
import IconLeaf from "../images/who-we-are/leaf.inline.svg"
import IconNewspaper from "../images/who-we-are/newspaper.inline.svg"
import IconWindmill from "../images/who-we-are/windmill.inline.svg"
import ChartDonations from "../images/who-we-are/donations_chart.inline.svg"
import OrgChartDesktop from "../images/who-we-are/orgchart.inline.svg"
import OrgChartMobile from "../images/who-we-are/orgchart-mobile.inline.svg"
import Stat from "../components/stat"
import Slider from "../components/slider"
import { AppendixWaypoint, Appendix } from "../components/appendix"

const PAGESLUG = "who-we-are"

export default function WhoWeAre() {
  return (
    <Layout>
      <SubNavigation id="Who We Are" />
      <Hero
        image="who-we-are/who-we-are-hero.jpg"
        title="Who We Are"
        text="The International Monetary Fund (IMF) is a global organization of 190 member countries set up to promote the health of the world economy. It works to foster global monetary cooperation, secure financial stability, facilitate international trade, promote high employment and sustainable economic growth, and reduce poverty around the world."
      />
      <span className="anchor" id="imf-organization-chart" />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h2 className="title--secondary title--uppercase">
              IMF Organization Chart
            </h2>
            <h3 className="title--meta title--light title--uppercase">
              As of April 30, 2020
            </h3>
          </div>
        </div>
        <div className="page__section__inner">
          <ul className="util__screen-reader-only">
            <li>International Monetary and Finance Committee</li>
            <li>
              <header>Board of Governors</header>
              <ul>
                <li>
                  <header>Executive Board</header>
                  <ul>
                    <header>
                      Managing Director and Deputy Managing Directors
                    </header>
                    <p>
                      The Managing Director and Deputy Managing Directors
                      oversee the Knowledge Management Unit, the Investment
                      Office-Staff Retirement Plan, the Office of Budget and
                      Planning, the Office of Internal Audit, the Office of Risk
                      Management, the Change Management Unit, and the iLab.
                    </p>
                    <ul>
                      <li>
                        <header>Area Departments</header>
                        <ul>
                          <li>African Department</li>
                          <li>
                            Asia and Pacific, with a Regional Office for Asia
                            and the Pacific
                          </li>
                          <li>European Department, with Offices in Europe</li>
                          <li>Middle Easy and Central Asia Department</li>
                          <li>Western Hemisphere Department</li>
                        </ul>
                      </li>
                      <li>
                        <header>
                          Functional and Special Services Department
                        </header>
                        <ul>
                          <li>Communications Department</li>
                          <li>Finance Department</li>
                          <li>Fiscal Affairs Department</li>
                          <li>
                            Institute for Capacity Development, including The
                            African Training Institute, the Joint Vienna
                            Institute, the Middle East Center for Economics and
                            Finance (in Kuwait), and the Singapore Training
                            Institute
                          </li>
                          <li>Legal Department</li>
                          <li>Monetary and Capital Markets Department</li>
                          <li>Research Department</li>
                          <li>Statistics Department</li>
                          <li>
                            Strategy, Policy, and Review Department, including
                            the IMF Office United Nations²
                          </li>
                        </ul>
                      </li>
                      <li>
                        <header>Area Departments</header>
                        <ul>
                          <li>Corporate Services and Facilities</li>
                          <li>Human Resources Department</li>
                          <li>Information Technology Department</li>
                          <li>Secretary's Department</li>
                        </ul>
                      </li>
                    </ul>
                  </ul>
                </li>
                <li>Independent Evaluation Office</li>
              </ul>
            </li>
            <li>Joint IMF-World Bank Development Committee¹</li>
            <footer>
              Footnotes:
              <ol>
                <li>
                  Known formally as the Joint Ministerial Committee of the Board
                  of Governors of the Bank and the Fund on the Trasfer of Real
                  Resources to Developing Countries.
                </li>
                <li>Attached to the Office of teh Managing Director.</li>
              </ol>
            </footer>
          </ul>
          <figure
            className="container container--padding-top-none"
            role="presentation"
          >
            <div className="util__tablet-up">
              <div
                className="scaling-svg-container"
                style={{ paddingBottom: "115%" }}
              >
                <OrgChartDesktop />
              </div>
            </div>

            <div className="util__tablet-down">
              <div
                className="scaling-svg-container"
                style={{ paddingBottom: "431%" }}
              >
                <OrgChartMobile />
              </div>
            </div>
          </figure>
        </div>
      </section>
      <span className="anchor" id="executive-directors" />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h2 className="title--secondary title--uppercase">
              Executive Directors
            </h2>
            <h3 className="title--meta title--light title--uppercase">
              As of April 30, 2020
            </h3>
            <p>
              The Executive Board is responsible for conducting the day-to-day
              business of the IMF. It is composed of 24 Directors, who are
              elected by member countries or by groups of countries, and the
              Managing Director, who serves as its Chair. As the COVID-19
              pandemic unfolded, IMF operations moved into a virtual boardroom
              with the Executive Directors participating from home.
            </p>
          </div>
        </div>
        <div className="page__section__inner">
          <PeopleGrid id="Executive Directors" />
        </div>
      </section>
      <span className="anchor" id="management-team" />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h2 className="title--secondary title--uppercase">
              Management team
            </h2>
            <p>
              The IMF has a Managing Director, who is head of the staff and
              Chair of the Executive Board. The Managing Director is assisted by
              a First Deputy Managing Director and three other Deputy Managing
              Directors.
            </p>
          </div>
        </div>
        <div className="page__section__inner">
          <PeopleGrid id="Management Team" className="people-grid--jumbo" />
        </div>
      </section>
      <span className="anchor" id="corporate-social-responsibility" />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h2 className="title--primary title--uppercase">
              Corporate Social Responsibility
            </h2>
            <p>
              The IMF is committed to improving the world we live in and being
              mindful of the impact of our operations. Environmental
              sustainability and philanthropic initiatives are at the core of
              the IMF’s corporate social responsibility program.
            </p>
          </div>
        </div>
        <div className="page__section__inner">
          <div className="container container--full container--padding-top-none">
            <Image
              path="who-we-are/csr_hero.jpg"
              caption="Children in rural Central America attend elementary school classes supported by an IMF annual grant. (Photo credit: School the World)"
            />
          </div>
        </div>
      </section>
      <section className="page__section page__section--sidebars">
        <div className="page__section__sidebar page__section__sidebar--left"></div>
        <div className="page__section__inner">
          <div className="container container--medium container--padding-top-none">
            <h2 className="title--secondary title--uppercase">
              Environmental Sustainability
            </h2>
            <p>
              The IMF has implemented several actions to reduce its
              environmental footprint and support the United Nations Sustainable
              Development Goals. Over the past 10 years, the IMF’s annual
              greenhouse gas footprint decreased by more than 10 percent (or
              some 7,000 metric tons of CO2e) through the establishment of
              energy, water, and waste policies. This is equivalent to removing
              about 1,500 passenger vehicles from the roads. The IMF’s
              greenhouse gas emissions are fully offset.
            </p>
            <Image
              path="who-we-are/greenhouse-footprint.jpg"
              caption="The IMF’s annual Greenhouse Gas Footprint decreased by more than ten percent."
            />
            <AppendixWaypoint page={PAGESLUG} id={13} />
            <div className="util__mobile-only" style={{ marginTop: "2rem" }}>
              <SustainabilityMeasures />
            </div>
          </div>
        </div>
        <div className="page__section__sidebar page__section__sidebar--right page__section__sidebar--justify-center">
          <SustainabilityMeasures />
        </div>
      </section>
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h2 className="title--secondary title--uppercase">
              Giving Together
            </h2>
            <p>
              Giving Together is the IMF’s philanthropic program supported by
              employees, retirees, and the IMF’s corporate giving.
            </p>
            <p>
              This was the IMF’s biggest year yet for charitable giving. Total
              donations to nonprofit organizations around the world amounted to
              $4.2 million in FY 2020.
            </p>
            <p>
              The annual Giving Campaign broke records in both dollars raised
              and staff participation. For the first time in campaign history,
              the IMF matched all contributions dollar for dollar—up from 50
              percent matching previously. In addition, the Giving Together
              program organized fundraisers for the victims of natural disasters
              in The Bahamas, Albania, Australia, and at the outset of the
              COVID-19 outbreak in China. After the global pandemic was
              declared, a humanitarian appeal raised $288,000 for the WHO
              Solidarity Response Fund.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={12} />
            <h3 className="page__quote">
              This was the IMF's biggest year yet for charitable giving. Total
              donations to nonprofit organizations around the world{" "}
              <em className="theme-color--wine">
                amounted to $4.2 Million in FY 2020.
              </em>
            </h3>
            <p>
              In total, IMF employees and retirees raised $3.6 million in
              donations and matching funds to support charitable causes and
              humanitarian relief efforts—exceeding last year’s figure of $3
              million.
            </p>
            <p>
              The IMF also awarded $215,000 in grants to charities worldwide in
              FY 2020, as well as $200,000 in exceptional grants to local
              nonprofit organizations in response to the COVID-19 pandemic. In
              addition, corporate donations totaling $110,000 were provided by
              senior management during mission travel to developing economies to
              support grassroots charities.
            </p>
            <p>
              To support the local community, staff volunteered to help
              nonprofit organizations serving the Washington, DC area, including
              by assembling winter kits for the homeless, hygiene kits for women
              in shelters, teaching financial literacy and English tutoring to
              high school students, and making masks for health workers.
            </p>
          </div>
        </div>
        <div className="page__section__inner">
          <div className="container container--full container--padding-top-none">
            <header>
              <h3 className="title--tertiary title--uppercase">
                Total Raised In Donations and Matching Funds
              </h3>
              <p className="title--meta title--uppercase title--light">
                (Millions of US Dollars)
              </p>
            </header>
            <div className="chart-stats">
              <div className="chart-stats__chart">
                <figure
                  className="scaling-svg-container"
                  style={{ paddingBottom: "55%" }}
                  aria-label="Chart of Employee and Retiree Donations and Matching Funds from 2016 to 2020. Employee and Retiree Donations grew steadily from 2016 to 2020 from approximately $1.15 million to $2 million. Matching Funds increased steadily over the same period from approximately $0.6 million to $1.6 million. Total Employee and Retiree Donations and Matching Funds from 2016 to 2020 increased from approximately $1.75 to $3.6 million."
                >
                  <ChartDonations />
                </figure>
              </div>
              <ul className="chart-stats__stats">
                <li>
                  <h3 className="title--meta title--uppercase">
                    Among the recipients of the Giving Together program in FY
                    2020
                  </h3>
                </li>
                <li>
                  <Stat
                    prefix="$"
                    number={288000}
                    note="raised for the WHO Solidarity Response Fund"
                  />
                </li>
                <li>
                  <Stat
                    prefix="$"
                    number={215000}
                    note="in grants to charities wordlwide"
                  />
                </li>
                <li>
                  <Stat
                    prefix="$"
                    number={200000}
                    note="to local nonprofits in response to COVID-19"
                  />
                </li>
                <li>
                  <Stat
                    prefix="$"
                    number={110000}
                    note="in corporate donations to support grassroots charities"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="page__section">
        <div className="page__section__inner" style={{ marginBottom: "4rem" }}>
          <Slider id="csr" title="Donations, Volunteering, and Giving" />
        </div>
      </section>
      <Appendix page={PAGESLUG} />
    </Layout>
  )
}

function SustainabilityMeasures() {
  return (
    <section className="icon-list">
      <h3 className="title--quaternary">Sustainability Measures in 2020</h3>
      <ul>
        <li>
          <div className="icon-list__icon">
            <IconLeaf />
          </div>
          Approximately 50,000 pounds of electronic waste were either donated or
          recycled responsibly.
        </li>
        <li>
          <div className="icon-list__icon">
            <IconNewspaper />
          </div>
          Through outreach and education on e-resources, the joint IMF/World
          Bank library reduced hardcopy news susbscriptions by 40 precent.
        </li>
        <li>
          <div className="icon-list__icon">
            <IconWindmill />
          </div>
          The IMF recently partnered with the US general services administration
          to invest in the US based green energy projects or renewable energy
          certificates equivalent to the IMF’s energy usages at its
          headquarters.
        </li>
      </ul>
    </section>
  )
}
